<template>
  <div class="fixed bottom-4 left-0 right-0 pointer-events-none">
    <div
      class="w-full mx-auto pointer-events-auto flex justify-end px-4 xl:max-w-screen-xl lg:max-w-screen-lg md:max-w-screen-md"
    >
      <div class="flex gap-2 bg-white rounded-full p-2 w-fit z-50">
        <FloatingButton
          v-if="endDate && new Date(endDate) >= new Date()"
          :icon="ThinPencilIcon"
          button-type="rounded"
          :fixed="false"
          @click="onProgressUpdate"
        />
        <FloatingButton
          v-else
          :icon="ThinPencilIcon"
          button-type="rounded"
          :fixed="false"
          :disabled="true"
        />
        <FloatingButton
          v-if="customChallengeId"
          :icon="StatisticsIcon"
          button-type="rounded"
          :fixed="false"
          @click="redirectToStatistics()"
        />
        <FloatingButton
          v-else-if="competitiveChallengeId"
          :icon="StatisticsIcon"
          button-type="rounded"
          :fixed="false"
          @click="redirectToCompetitiveStatistics()"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FloatingButton from "./FloatingButton.vue";
import ThinPencilIcon from "../../icon/ThinPencilIcon.vue";
import StatisticsIcon from "../../icon/StatisticsIcon.vue";

const router = useRouter();

const props = defineProps<{
  customChallengeId?: string;
  competitiveChallengeId?: string;
  onProgressUpdate?: () => void;
  endDate?: string;
}>();

function redirectToStatistics() {
  router.push({
    name: "challengeStatistics",
    params: {
      challengeId: props.customChallengeId,
    },
  });
}

function redirectToCompetitiveStatistics() {
  router.push({
    name: "competitiveChallengeStatistics",
    params: {
      challengeId: props.competitiveChallengeId,
    },
  });
}
</script>
